import { Songcard } from "@/types";
import { Store } from "@tanstack/react-store";

export const cardStore = new Store({
  card: {
    id: 0,
    title: "",
    uuid: "",
    comp_file: "",
    ext_file: "",
    image: "",
    desc: "",
    song: {
      title: "",
      file: "",
      ext_file: "",
    },
    primary_artist: {
      name: "",
      about: "",
      slug: "",
    },
    files: [{ file_name: "", file: "", ext_file: "" }],
  } as Songcard,
});

export const updateNowPlayingCard = (card: Songcard) => {
  cardStore.setState((state) => {
    return {
      ...state,
      card: card,
    };
  });
};
